// =========================
// FILTERS
// =========================
import './app/filters/getAmazonLink.filter';

// =========================
// Bootstrap frameworks
// =========================
import './app/main';

const Vue = window.Vue;

Vue.component('item-store-special', () => import('./app/components/itemList/ItemStoreSpecial.vue'));
Vue.component('item-image-carousel', () => import('./app/components/item/ItemImageCarousel.vue'));

Vue.filter('customImagesAccessor', function (images, accessor) {
  if (!images) {
    return [];
  }

  const imageUrls = [];

  const imagesAccessor = 'all';

  for (const image in images[imagesAccessor]) {
    const imageUrl = images[imagesAccessor][image][accessor];
    const alternate = images[imagesAccessor][image].names ? images[imagesAccessor][image].names.alternate : null;
    const name = images[imagesAccessor][image].names ? images[imagesAccessor][image].names.name : null;

    imageUrls.push({ url: imageUrl, position: images[imagesAccessor][image].position, alternate, name });
  }

  return imageUrls;
});
